import { BusEvent } from '@web/common';

export class WarehouseReleaseChangedBusEvent extends BusEvent {}
